import { findProhorIntentReply } from "@/store/prohor/prohorMatch";
import { NOT_AVAILABLE_MESSAGE } from "@/store/prohor/prohorLine1";
import { PROHOR_QUESTION_POOL } from "@/store/prohor/prohorQuestionPool";

const HR_GUIDE_INTENTS_CORE = [
    {
        id: "start-work",
        matchAll: [
            ["с", "чего", "начать"],
            ["как", "начать", "работ"],
            ["что", "нужно", "старт"],
            ["что", "делать", "старт"],
            ["первые", "шаг"],
            ["новый", "hr"],
            ["только", "зашел"],
            ["онбординг"],
            ["инструкц", "старт"],
        ],
        roles: {
            hrMain: {
                text:
                    "Добро пожаловать! Рекомендуемый путь для главного HR:\n\n" +
                    "1) «Моя компания» — обзор и доступы компании.\n" +
                    "2) «Сотрудники» — добавить команду (вручную или Excel).\n" +
                    "3) «Группы» — объединить сотрудников для массовых действий.\n" +
                    "4) «Каталог» → «Заказы» — закупить квоты на тесты (и при необходимости курсы).\n" +
                    "5) «Группы» / «Оценка» — выдать тестирование.\n" +
                    "6) «Оценка» / «Аналитика» — контроль и отчёты.\n\n" +
                    "Пошаговый чеклист — в разделе «Начало работы».",
                action: { label: "Чеклист старта", route: "/begin" },
            },
            hrSub: {
                text:
                    "Для HR подразделения:\n\n" +
                    "1) «Группы» — ваши команды.\n" +
                    "2) «Оценка» — выдача тестов и скачивание отчётов в своих группах.\n" +
                    "3) «Развитие» — курсы и прогресс.\n" +
                    "4) Закупку квот оформляет главный HR — напишите ему, если не хватает доступов.\n\n" +
                    "Чеклист — в «Начало работы».",
                action: { label: "Чеклист старта", route: "/begin" },
            },
            staff: {
                text:
                    "Для сотрудника:\n\n" +
                    "1) Дождитесь назначения теста или курса от HR.\n" +
                    "2) Откройте «Моё развитие» — там все назначения.\n" +
                    "3) Пройдите тест за 24 часа с момента начала (непрерывно).\n" +
                    "4) Скачайте отчёт, если HR разрешил просмотр.\n\n" +
                    "Свой профиль и пароль — в «Профиль».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "first-testing-flow",
        matchAll: [
            ["перв", "тестиров"],
            ["выдать", "перв"],
            ["запуст", "перв"],
            ["что", "нужно", "выдать", "тест"],
            ["как", "выдать", "тестиров"],
            ["первое", "тестирован"],
        ],
        roles: {
            hrMain: {
                text:
                    "Чтобы выдать первое тестирование:\n\n" +
                    "1) Добавьте сотрудников («Сотрудники»).\n" +
                    "2) Создайте или выберите группу («Группы»).\n" +
                    "3) Закупите квоты в «Каталоге», если их нет.\n" +
                    "4) Выдайте тест: «Оценка» или обзор группы → «Управление доступами» → тип отчёта.\n" +
                    "5) Сотрудник проходит тест в течение 24 ч после начала.\n" +
                    "6) Скачайте отчёт в «Оценке» после завершения.\n\n" +
                    "Рекомендация: не чаще 1 раза в 6 месяцев на сотрудника.",
                action: { label: "К оценке", route: "/rating" },
            },
            hrSub: {
                text:
                    "В ваших группах: «Группы» → обзор группы → выберите сотрудников → " +
                    "«Управление доступами» → тип отчёта. Или массово через «Оценка». " +
                    "Квоты закупает главный HR.",
                action: { label: "К группам", route: "/groups" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "assign-test-one",
        matchAll: [
            ["одному", "сотрудник"],
            ["один", "сотрудник", "тест"],
            ["выдать", "одному"],
            ["тест", "одному"],
            ["одному", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Одному сотруднику: «Оценка» → отметьте одного в таблице → " +
                    "«Управление доступами» → выберите тип отчёта (стандартный, управленческий и т.д.). " +
                    "Повторно — только если нет незавершённого прохождения.",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text:
                    "То же в «Оценке» или в обзоре своей группы — один сотрудник, «Управление доступами».",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "assign-test-group",
        matchAll: [
            ["групп", "тест"],
            ["выдать", "групп"],
            ["назнач", "групп", "тест"],
            ["тестирован", "групп"],
            ["тест", "групп"],
            ["групп", "тестирован"],
        ],
        roles: {
            hrMain: {
                text:
                    "Группе: «Группы» → обзор группы → чекбоксы сотрудников → " +
                    "«Управление доступами» → тип отчёта. Альтернатива: «Оценка» с фильтром по группе.",
                action: { label: "Группы", route: "/groups" },
            },
            hrSub: {
                text: "В своих группах — обзор группы или «Оценка» с фильтром по группе.",
                action: { label: "Группы", route: "/groups" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "distribute-to-groups",
        matchAll: [
            ["распредел", "групп"],
            ["перенест", "квот", "групп"],
            ["квот", "групп"],
        ],
        roles: {
            hrMain: {
                text:
                    "Распределение: «Группы» → откройте группу → перенесите квоты с баланса компании " +
                    "на группу («Выдать прохождения» / перенос квот). Затем выдайте тесты из группы или «Оценки».",
                action: { label: "Группы", route: "/groups" },
            },
            hrSub: {
                text: "В пределах назначенных вам групп — на карточке группы, перенос квот и выдача доступов.",
                action: { label: "Группы", route: "/groups" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "assign-course-trainer",
        matchAll: [
            ["выдать", "курс"],
            ["назнач", "курс"],
            ["выдать", "тренажер"],
            ["назнач", "тренажер"],
            ["курс", "сотрудник"],
            ["тренажер", "сотрудник"],
        ],
        roles: {
            hrMain: {
                text:
                    "Курсы: раздел «Развитие» или обзор группы → «Управление доступами».\n" +
                    "Тренажёры: «Ежедневные помощники» — та же логика квот.\n" +
                    "Сотрудник проходит курс по ссылке (LMS в новой вкладке), прогресс — в «Моё развитие». " +
                    "Квота на курс/тренажёр живёт 1 год с покупки.",
                actions: [
                    { label: "Развитие", route: "/courses" },
                    { label: "Помощники", route: "/instruments" },
                ],
            },
            hrSub: {
                text:
                    "В своих группах — «Управление доступами» для курсов и тренажёров. " +
                    "Обзор — «Развитие» и «Ежедневные помощники».",
                actions: [
                    { label: "Развитие", route: "/courses" },
                    { label: "Помощники", route: "/instruments" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "no-quota",
        matchAll: [
            ["нет", "квот"],
            ["не", "хватает", "квот"],
            ["нет", "подписк"],
            ["заказать", "доступ"],
        ],
        roles: {
            hrMain: {
                text:
                    "Не хватает квот: в окне «Управление доступами» → «Заказать доступы» или " +
                    "«Каталог решений» → оформите заказ → «Заказы». " +
                    "Без подписки часть разделов (аналитика, дневник, навигатор) может быть недоступна — см. «Подписка» / каталог.",
                action: { label: "Каталог", route: "/catalog" },
            },
            hrSub: {
                text:
                    "Закупку оформляет главный HR. Напишите ему, какие тесты или курсы нужны. " +
                    "Статусы заказов можно смотреть в «Заказы».",
                action: { label: "Заказы", route: "/my-orders" },
            },
            staff: {
                text: "Доступы назначает HR/руководитель. Напишите ему, если ожидаете тест или курс.",
                action: null,
            },
        },
    },

    {
        id: "what-is-rating-section",
        matchAll: [
            ["что", "такое", "оценк"],
            ["что", "раздел", "оценк"],
            ["зачем", "оценк"],
        ],
        roles: {
            hrMain: {
                text:
                    "«Оценка» — операционный раздел для HR: кому выдан тест, статусы (не начат / в процессе / " +
                    "завершён / просрочен), напоминания, скачивание отчётов по команде, настройка видимости отчёта сотруднику.\n\n" +
                    "Это не путать с «Аналитика → Отчёты» — там сводные и специальные отчёты по группам/компании.",
                action: { label: "Открыть оценку", route: "/rating" },
            },
            hrSub: {
                text:
                    "«Оценка» — ваш рабочий стол по тестам команды: выдача, статусы, PDF-отчёты после прохождения.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "Сотрудники не работают в «Оценке». Ваши назначенные тесты — в «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "what-is-testing",
        matchAll: [
            ["что", "такое", "тестирован"],
            ["что", "дает", "тест"],
            ["зачем", "тестирован"],
            ["зачем", "проходить", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Тестирование — интерактивное прохождение методики ТЭИ в ЛК (обычно 15–60 минут, непрерывно). " +
                    "После успешного завершения формируется отчёт (PDF). " +
                    "Цепочка: закупка квоты → назначение HR → прохождение (24 ч с начала) → отчёт → аналитика и развитие.\n\n" +
                    "Зачем компании: объективная оценка ЭИ, отбор, развитие, эталоны.",
                action: { label: "Каталог", route: "/catalog" },
            },
            hrSub: {
                text:
                    "Тестирование — прохождение ТЭИ сотрудником; HR видит статусы в «Оценке» и скачивает отчёты.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "Это ваш назначенный тест ЭИ. Откройте «Моё развитие», начните и завершите в течение 24 часов. " +
                    "Отчёт появится, если HR разрешил просмотр.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "why-buy-tests",
        matchAll: [
            ["зачем", "покуп"],
            ["зачем", "закуп"],
            ["зачем", "купить", "тест"],
            ["зачем", "нужн", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Тесты и квоты нужны, чтобы: оценить ЭИ сотрудников и команд, получить отчёты, " +
                    "строить аналитику (ЭИ-профиль, динамика), подобрать курсы и тренажёры. " +
                    "Квота живёт 1 год с покупки. Закупка — «Каталог решений».",
                action: { label: "Каталог", route: "/catalog" },
            },
            hrSub: {
                text: "Закупкой занимается главный HR. Опишите ему, какие тесты и объёмы нужны.",
                action: null,
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "report-types-standard",
        matchAll: [
            ["стандартн", "отчет"],
            ["тип", "отчет", "стандарт"],
        ],
        roles: {
            hrMain: {
                text:
                    "Стандартный отчёт — для линейного персонала и массовой оценки ЭИ. " +
                    "Один PDF после завершения. Закупка в каталоге, выдача через «Оценку».",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Стандартный отчёт — базовый PDF по ЭИ для сотрудника. Выдача в «Оценке».",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text: "Если HR назначил стандартный тест — отчёт появится в «Моё развитие» после прохождения.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "report-types-management",
        matchAll: [
            ["управленческ", "потенциал"],
            ["управленческ", "отчет"],
        ],
        roles: {
            hrMain: {
                text:
                    "Управленческий потенциал — для руководителей и резерва. После прохождения — " +
                    "два PDF: для заказчика (HR) и для сотрудника (если включена видимость).",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Управленческий отчёт — две версии PDF. Выдача как у стандартного, тип «управленческий потенциал».",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text: "При назначении управленческого теста вы получите свою версию отчёта, если HR разрешил.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "trainers-explained",
        matchAll: [
            ["что", "тренажер"],
            ["зачем", "тренажер"],
            ["ежедневн", "помощник"],
        ],
        roles: {
            hrMain: {
                text:
                    "Тренажёры («Ежедневные помощники») — ежедневная практика навыков ЭИ после оценки. " +
                    "Назначение через группы / доступы. Квота 1 год с покупки.",
                action: { label: "Помощники", route: "/instruments" },
            },
            hrSub: {
                text: "Тренажёры назначаются в группах. Обзор — «Ежедневные помощники».",
                action: { label: "Помощники", route: "/instruments" },
            },
            staff: {
                text: "Назначенные тренажёры — в «Моё развитие» и «Ежедневные помощники».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "courses-explained",
        matchAll: [
            ["что", "такое", "курс"],
            ["где", "проход", "курс"],
            ["зачем", "курс"],
            ["как", "отслеж", "курс"],
        ],
        roles: {
            hrMain: {
                text:
                    "Курсы — системное развитие ЭИ. HR: раздел «Развитие» — назначение и прогресс в процентах. " +
                    "Сотрудник открывает курс по ссылке (внешняя LMS, новая вкладка). " +
                    "Квота 1 год + в заказе задаётся срок доступа к конкретному курсу.",
                action: { label: "Развитие", route: "/courses" },
            },
            hrSub: {
                text: "Назначение курсов — в группах или «Развитие». Прогресс виден в таблице.",
                action: { label: "Развитие", route: "/courses" },
            },
            staff: {
                text: "Курсы в «Моё развитие» — кнопка «Пройти» ведёт на LMS. Прогресс обновляется в ЛК.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },

    {
        id: "result-delivery-variants",
        matchAll: [
            ["вариант", "предоставлен", "результат"],
            ["вариант", "результат"],
            ["какие", "отчет", "вариант"],
            ["формат", "результат"],
            ["как", "получить", "результат"],
        ],
        roles: {
            hrMain: {
                text:
                    "Варианты предоставления результатов:\n\n" +
                    "• PDF по тестированию (стандартный, экспертный) — в разделе «Оценка» после завершения прохождения.\n" +
                    "• Управленческий потенциал — два PDF: для сотрудника и для заказчика (HR).\n" +
                    "• Просмотр отчёта сотрудником в личном кабинете — если вы включили видимость.\n" +
                    "• Массовая выгрузка отчётов по группе — в «Оценке» или в карточке группы.\n" +
                    "• Сводная таблица всех прохождений — в «Оценке», кнопка «Сводная таблица».\n" +
                    "• Специальные аналитические отчёты (ЭИ-профиль, сравнение групп, динамика до/после) — «Аналитика → Отчёты».\n" +
                    "• Эталонный профиль — отдельный продукт, раздел эталонных профилей.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Сводная таблица", route: "/detailed" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                    { label: "Эталонный профиль", route: "/references/list" },
                ],
            },
            hrSub: {
                text:
                    "PDF по команде — «Оценка». Специальные сводные отчёты — «Аналитика → Отчёты». " +
                    "Видимость отчёта для сотрудника настраивается в «Оценке».",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Аналитика", route: "/analytics/reports" },
                ],
            },
            staff: {
                text:
                    "Ваш отчёт (если HR разрешил) — в «Личный кабинет» и «Моё развитие» после завершения теста.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },

    {
        id: "test-shelf-life",
        matchAll: [
            ["срок", "годност"],
            ["срок", "действ", "тест"],
            ["когда", "сгор", "тест"],
            ["сколько", "живет", "квот"],
        ],
        roles: {
            hrMain: {
                text:
                    "Квота на тест (любой тип: стандартный, управленческий, экспертный) живёт 1 год с момента покупки. " +
                    "После начала прохождения сотрудник должен завершить тест в течение 24 часов, иначе результат аннулируется " +
                    "(новую квоту выдавать не обязательно — можно напомнить о прохождении). " +
                    "Отозвать квоту можно, только если сотрудник не начинал тест.",
                action: { label: "Моя компания", route: "/" },
            },
            hrSub: {
                text:
                    "Квота теста — 1 год с покупки. На прохождение после старта — 24 часа. " +
                    "Сроки по заказам — в «Моя компания» или у главного HR.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "После начала теста у вас 24 часа на завершение. " +
                    "Рекомендуем проходить непрерывно, 15–60 минут. " +
                    "Повторное назначение — по решению HR (обычно не чаще раза в полгода).",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "test-retake-frequency",
        matchAll: [
            ["как", "часто", "проход"],
            ["как", "часто", "тест"],
            ["повторн", "проход"],
            ["перепрохож"],
            ["раз", "полгода"],
        ],
        roles: {
            hrMain: {
                text:
                    "Рекомендация для HR: не чаще 1 раза в 6 месяцев на сотрудника. " +
                    "Повторная выдача в ЛК возможна, если нет незавершённого прохождения (или после статуса «завершён»). " +
                    "Для динамики «до/после» в аналитике нужны первичный и повторный проход.",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Те же правила: рекомендация 1 раз в 6 мес., повторная выдача без активного незавершённого теста.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "Частоту повторного теста определяет HR (ориентир — раз в полгода). " +
                    "Если тест назначен снова — откройте «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "test-duration-validity",
        matchAll: [
            ["15", "минут"],
            ["60", "минут"],
            ["недостоверн"],
            ["долго", "проход"],
            ["быстро", "прошел"],
        ],
        roles: {
            hrMain: {
                text:
                    "Если тест пройден менее 15 минут или более 1 часа, результат может быть недостоверным — " +
                    "рекомендуйте перепрохождение. Нормальный ориентир — 15–60 минут, непрерывно.",
                action: null,
            },
            hrSub: {
                text: "Ориентир прохождения: 15–60 минут непрерывно; слишком быстро или долго — возможна недостоверность.",
                action: null,
            },
            staff: {
                text:
                    "Проходите тест спокойно и непрерывно, ориентир 15–60 минут. " +
                    "После начала — завершите в течение 24 часов.",
                action: null,
            },
        },
    },

    {
        id: "what-in-lk",
        matchAll: [
            ["что", "есть", "личн"],
            ["что", "у", "меня", "кабинет"],
            ["что", "в", "личн", "кабинет"],
        ],
        roles: {
            hrMain: {
                text:
                    "У главного HR в ЛК: данные компании, все сотрудники и группы, под-HR, «Оценка», «Развитие», " +
                    "каталог и заказы, подписка, аналитика, уведомления, свой профиль и «Моё развитие».\n\n" +
                    "Спросите «сколько у меня тестов» — подскажу цифры по квотам, если загрузятся с сервера.",
                action: { label: "Моя компания", route: "/" },
            },
            hrSub: {
                text:
                    "У под-HR: свои группы, «Оценка», «Развитие», аналитика по зоне, заказы (просмотр), плюс личные разделы " +
                    "(«Личный кабинет», «Моё развитие»). Закупка и компания — у главного HR.",
                action: { label: "Группы", route: "/groups" },
            },
            staff: {
                text:
                    "У вас: «Личный кабинет» (ваши отчёты ЭИ), «Моё развитие» (тесты, курсы, тренажёры), " +
                    "при подписке — дневник, навигатор, библиотека, профиль, помощь.",
                action: { label: "Личный кабинет", route: "/personal" },
            },
        },
    },
    {
        id: "what-can-in-lk",
        matchAll: [
            ["что", "могу", "личн"],
            ["что", "можно", "кабинет"],
            ["что", "делать", "личн"],
        ],
        roles: {
            hrMain: {
                text:
                    "Вы можете: закупать квоты, распределять по группам, назначать тесты и курсы, напоминать о прохождении, " +
                    "скачивать отчёты, настраивать видимость, строить аналитику и эталоны, управлять под-HR и уведомлениями.",
                action: { label: "Помощь с ЛК", route: "/faq" },
            },
            hrSub: {
                text:
                    "Вы можете: в своих группах выдавать и отзывать доступы, напоминать о тестах, скачивать отчёты, " +
                    "смотреть прогресс курсов. Закупку и подписку — через главного HR.",
                action: { label: "Помощь с ЛК", route: "/faq" },
            },
            staff: {
                text:
                    "Вы можете: проходить назначенные тесты (24 ч с начала), открывать курсы по ссылке, " +
                    "скачивать свой отчёт (если разрешено), пользоваться дневником и навигатором при подписке.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "why-lk",
        matchAll: [
            ["зачем", "личн", "кабинет"],
            ["для", "чего", "личн", "кабинет"],
            ["зачем", "нужен", "лк"],
        ],
        roles: {
            hrMain: {
                text:
                    "ЛК нужен, чтобы управлять программой оценки и развития ЭИ в компании: от закупки квот до отчётности и аналитики — в одном месте.",
                action: { label: "Моя компания", route: "/" },
            },
            hrSub: {
                text:
                    "ЛК для под-HR — делегированное управление оценкой и обучением в подразделении без полномочий заказчика.",
                action: { label: "Группы", route: "/groups" },
            },
            staff: {
                text:
                    "ЛК для вас — пройти оценку ЭИ, получить отчёт и развивать компетенции по назначенной траектории.",
                action: { label: "Личный кабинет", route: "/personal" },
            },
        },
    },

    {
        id: "menu-why-rating",
        matchAll: [
            ["зачем", "раздел", "оценк"],
            ["зачем", "меню", "оценк"],
            ["для", "чего", "оценк"],
        ],
        roles: {
            hrMain: {
                text:
                    "Пункт «Оценка» — выдача тестов, статусы прохождений, напоминания, скачивание PDF, настройка видимости отчётов сотрудникам.",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "«Оценка» — основной раздел для работы с тестами ваших групп.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "menu-why-analytics",
        matchAll: [
            ["зачем", "аналитик"],
            ["для", "чего", "аналитик"],
            ["зачем", "мониторинг"],
        ],
        roles: {
            hrMain: {
                text:
                    "«Аналитика»: «Мониторинг» — дашборд KPI; «Отчёты» — спецотчёты (ЭИ-профиль, сравнение групп, динамика, эталон). " +
                    "Не путать с операционной «Оценкой».",
                actions: [
                    { label: "Мониторинг", route: "/analytics/dashboard" },
                    { label: "Отчёты", route: "/analytics/reports" },
                ],
            },
            hrSub: {
                text: "Аналитика по вашим группам — мониторинг и спецотчёты. Нужны завершённые тестирования.",
                action: { label: "Отчёты", route: "/analytics/reports" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "change-password-how",
        matchAll: [
            ["как", "поменять", "парол"],
            ["как", "сменить", "парол"],
            ["изменить", "парол"],
        ],
        roles: {
            hrMain: {
                text: "Смена пароля: откройте раздел «Профиль» — там личные данные и смена пароля.",
                action: { label: "Профиль", route: "/profile" },
            },
            hrSub: {
                text: "«Профиль» — изменение пароля и личных данных.",
                action: { label: "Профиль", route: "/profile" },
            },
            staff: {
                text: "«Профиль» — ваши данные и смена пароля.",
                action: { label: "Профиль", route: "/profile" },
            },
        },
    },
];

const HR_GUIDE_INTENTS = [...PROHOR_QUESTION_POOL, ...HR_GUIDE_INTENTS_CORE];

export const findHrGuideReply = (question, role) =>
    findProhorIntentReply(question, role, HR_GUIDE_INTENTS);
